<div class="attachement">
	<div class="leftSide">
		{{ attachment?.name }}
	</div>

	@if (!disableDelete) {
		<div class="rightSide">
			<button mat-icon-button color="warn" (click)="deleteClicked()">
				<mat-icon fontSet="fad" fontIcon="fa-trash-alt" inline />
			</button>
		</div>
	}
	<div>
		<button mat-icon-button color="accent" (click)="downloadAttachments()">
			<mat-icon fontSet="fad" fontIcon="fa-download" inline />
		</button>
	</div>
</div>
